export type DemoCue = {
  at: number;
  dur?: number;
  caption?: string;
  effort?: number;
  mute?: number;
  note?: number;
  legato?: boolean;
  release?: boolean;
};

/** A short phrase on the Velvet bore: entrance, swell, slur, mute, release, a rough push. */
export const DEMO: DemoCue[] = [
  { at: 0.06, caption: "Soft entrance", effort: 0.22, mute: 0.08 },
  { at: 0.1, note: 48 },
  { at: 0.55, caption: "Swell — color lags the air", effort: 0.68, dur: 1.15 },
  { at: 1.9, caption: "Slur", note: 52, legato: true },
  { at: 2.55, note: 55, legato: true },
  { at: 2.62, caption: "Bloom", effort: 0.9, dur: 0.75 },
  { at: 3.6, caption: "Into the mute", mute: 0.9, dur: 0.95 },
  { at: 4.75, caption: "Open again", note: 52, legato: true, effort: 0.46, mute: 0.1, dur: 0.65 },
  { at: 5.9, caption: "Release — the tube rings", release: true },
  { at: 6.75, caption: "A brighter, rougher push", effort: 0.96, mute: 0.03 },
  { at: 6.9, note: 62 },
  { at: 7.75, release: true },
  { at: 8.35, caption: "Quiet reply", effort: 0.27, mute: 0.22 },
  { at: 8.5, note: 60 },
  { at: 9.6, release: true },
  { at: 10.25, caption: "Your turn" },
];

export const DEMO_LENGTH = 10.6;
